import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import AppUtil from "utilities/AppUtil";
import httpRequest from "../../services/httpRequest";
import snakecaseKeys from "snakecase-keys";
// Main URL Endpoint
const _urlPrefix = "/coordinator/participant";

export const fetchAllParticipants = createAsyncThunk(
    "coordinatorParticipant/fetchAllParticipants",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/list`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params)
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const fetchListParticipant = createAsyncThunk(
  "coordinatorParticipant/fetchListParticipant",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const fetchParticipantDetail = createAsyncThunk(
  "coordinatorParticipant/fetchParticipantDetail",
  async (params) => {
    const { id } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/detail/${id}`,
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceCreateParticipant = createAsyncThunk(
  "coordinatorParticipant/reduceCreateParticipant",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      method: "POST",
      data: snakecaseKeys(params),
      successMessage: "toast.create.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceUpdateParticipant = createAsyncThunk(
  "coordinatorParticipant/reduceUpdateParticipant",
  async (params) => {
    const { id } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/update/${id}`,
      method: "PUT",
      data: snakecaseKeys(params),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceChangeStatus = createAsyncThunk(
  "coordinatorParticipant/reduceChangeStatus",
  async (params) => {
    const { id, body } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/change/status/${id}`,
      method: "PUT",
      data: AppUtil.toSnakeCaseKey(body),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceDeleteParticipant = createAsyncThunk(
  "coordinatorParticipant/reduceDeleteParticipant",
  async (params) => {
    const data = {ids: params};
    const result = await httpRequest({
      url: `${_urlPrefix}/delete`,
      method: "DELETE",
      data: data,
      successMessage: "toast.remove.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

const initialState = {
  list: [],
  detail: {}
};

const coordinatorParticipant = createSlice({
  name: "coordinatorParticipant",
  initialState: initialState,
  reducers: {
  },
  extraReducers: {
    [fetchParticipantDetail.fulfilled]: (state, action) => {
      if (action.payload) {
        state.detail = action.payload;
        for (const key in state.detail) {
          if (!state.detail[key]) {
            state.detail[key] = '';
          }
        }
      }
    },
    [fetchListParticipant.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.list = payload.content;
      }
    }
  }
});

const { reducer } = coordinatorParticipant;
export default reducer;

export const getParticipantDetail = createSelector(
  (state) => state.coordinatorParticipant.detail,
  (user) => user
);
export const getParticipantList = createSelector(
  state => state.coordinatorParticipant.list,
  list => list
);
